// extracted by mini-css-extract-plugin
var _1 = "IFrameComponent-module__animateUploadProgressBarWidth--fdgik";
var _2 = "IFrameComponent-module__animatedBackground--_1Q0a";
var _3 = "IFrameComponent-module__container--mqT3V";
var _4 = "IFrameComponent-module__footer--uB5yM";
var _5 = "IFrameComponent-module__link--rA6TG";
var _6 = "IFrameComponent-module__logo--Bylyf";
var _7 = "IFrameComponent-module__upgrade--YfgdO";
var _8 = "IFrameComponent-module__upgradeDescription--r5dcs";
var _9 = "IFrameComponent-module__upgradeTitle--rZSuH";
var _a = "IFrameComponent-module__upsell--uuVUo";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "footer", _5 as "link", _6 as "logo", _7 as "upgrade", _8 as "upgradeDescription", _9 as "upgradeTitle", _a as "upsell" }
